import { FiRefreshCw } from 'react-icons/fi'
import { Tooltip } from 'components/Tooltip/tooltip'
import { cn } from 'components/UI/cn'

interface ResyncIconButtonProps {
  isExpired: boolean
  onSync: () => void
  /**
   * Layout/spacing classes for the outer wrapper (e.g. ``mr-3``).
   * Applied to the wrapper div so the component is the actual flex
   * child — Tooltip's implicit wrapper would otherwise swallow these
   * and collapse spacing.
   */
  className?: string
}

/**
 * Refresh icon used in the connections / email integration tables.
 *
 * When the underlying integration is expired (``isExpired=true``), the
 * icon is visually disabled and the click handler is detached. The
 * tooltip explains why and points the user at reauth — they can still
 * see the icon but cannot trigger a sync that would silently fail.
 */
export function ResyncIconButton({
  isExpired,
  onSync,
  className,
}: ResyncIconButtonProps): React.JSX.Element {
  return (
    <div className={className}>
      <Tooltip
        title={isExpired ? 'Reconnect required' : undefined}
        content={
          isExpired ? 'Reconnect this account before syncing' : 'Sync emails'
        }
        placement="top"
      >
        <FiRefreshCw
          size={20}
          className={cn(
            'text-fg-tertiary',
            isExpired ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'
          )}
          onClick={isExpired ? undefined : onSync}
        />
      </Tooltip>
    </div>
  )
}
